<template>
  <div class="myRegistration">
        <h3 class="containner-title">{{$t("message.expiration")}}</h3>
        <div class="card-body border" style="background-color: #f1f1f1;">
            <form class="form" v-on:submit.prevent>
              <div class="row mb-2">
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.last_name")}}</label>
                  <input type="text" 
                      class="form-control" 
                      v-model="search.lastname"
                      :placeholder="$t('message.last_name')" aria-label="Last name">
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.first_name")}}</label>
                  <input type="text" 
                    class="form-control" 
                    v-model="search.firstname"
                    :placeholder="$t('message.first_name')" 
                    aria-label="First name">
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.phone")}}</label>
                  <input type="text" 
                    class="form-control" 
                    v-model="search.phone"
                    :placeholder="$t('message.phone')">
                </div>
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.gender")}}</label>
                  <select
                    class="form-select"
                    v-model="search.gender"
                    :placeholder="$t('message.gender')"
                  >
                    <option value="">Choose...</option>
                    <option value="1">{{$t("message.male")}}</option>
                    <option value="2">{{$t("message.female")}}</option>
                  </select>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col">
                  <label for="first-name" class="form-label">{{$t("message.business_type")}}</label>
                  <select
                    class="form-select"
                    v-model="search.type_business"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="1">{{$t("message.stock_business")}}</option>
                    <option value="4">{{$t("message.found")}}</option>
                    <option value="2">{{$t("message.derivative_business")}}</option>
                    <option value="3">{{$t("message.public")}}</option>
                  </select>
                </div>
                <div class="col">
                  <label for="company" class="form-label">{{$t("message.company")}}</label>
                  <input type="text" 
                      class="form-control" 
                      v-model="search.company"
                      placeholder="company">
                </div>
                <div class="col">
                  <label for="company" class="form-label">{{$t("message.expiration_date")}}</label>
                  <select
                    class="form-select"
                    v-model="search.expiration_query"
                    placeholder="Status"
                  >
                    <option value="">Choose...</option>
                    <option value="1">បានផុតកំណត់</option>
                    <option value="2">ជិតផុតកំណត់រយះពេល៣ខែ</option>
                  </select>
                </div>
               
                <div class="col">
                  <label for="company" class="form-label">{{$t("message.status")}}</label>
                  <select
                    class="form-select"
                    v-model="search.status"
                    placeholder="Status"
                  >
                    <option value="">Choose...</option>
                    <option value="0">{{$t("message.inactive")}}</option>
                    <option value="1">{{$t("message.active")}}</option>
                  </select>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-12" style="text-align: right;margin-top: 5px;">

                  <!-- Button trigger modal -->
                  <button type="button" class="btn btn-primary me-2" 
                      data-bs-toggle="modal" 
                      data-bs-target="#exampleModal">
                    <i class="fas fa-file-excel"></i> Import Excel
                  </button>
                
                  <button class="btn btn-danger" @click="searchAction">
                    <i class="fas fa-search"></i> {{$t("message.search")}}
                  </button>
                </div>
              </div>
            </form>
        </div>
        <div class="row">
          <label class="text-end fs-5 fw-bold p-2">{{$t("message.total")}}: <span class="text-primary">{{listRegister.total}}</span></label> 
        </div>
        <table class="table table-bordered table-striped">
          <thead class="table-dark">
            <tr>
              <th class="align-middle text-center">#</th>
              <th class="align-middle text-center"></th>
              <th class="align-middle">{{$t("message.name")}}</th>
              <!-- <th class="align-middle text-center">{{$t("message.gender")}}</th>
              <th class="align-middle text-center">{{$t("message.dob")}}</th>
              <th class="align-middle text-center">{{$t("message.phone")}}</th> -->
              <th class="align-middle text-center">{{$t("message.nationality")}}</th>
              <th class="align-middle text-center">{{$t("message.company")}}</th>
              <th class="align-middle text-center" style="width:250px;">{{$t("message.business_type")}}</th>
              <th class="align-middle text-center">{{$t("message.expiration_date")}}</th>
              <th class="align-middle text-center">{{$t("message.status")}}</th>
              <th class="align-middle text-center">{{$t("message.action")}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in listRegister.data" :key="item.id">
              <th class="align-middle text-center" style="vertical-align: middle;width: 30px;">{{index+1}}</th>
              <td class="text-center" style="vertical-align: middle;">
                <img v-if="item.participant.avatar" class="avatar" :src=item.participant.avatar />
                <img v-else class="avatar" src="../../assets/images/usericone.png" />
              </td>
              <td style="vertical-align: middle;">
                 <label class="fw-bold" v-if="item.participant.lastname && item.participant.firstname">
                    {{item.participant.lastname + ' ' + item.participant.firstname}} ({{item.participant.lastname_en + ' ' + item.participant.firstname_en}})
                  </label>
                  <label class="fw-bold" v-else>
                    {{item.participant.lastname_en + ' ' + item.participant.firstname_en}}
                  </label>
                  <br/>
                <label class="fw-bold">{{$t("message.gender")}}</label>: {{item.participant.gender==1 ? "ប្រុស": item.participant.gender==2 ? "ស្រី" : ""}}<br/>
                <label class="fw-bold">{{$t("message.dob")}}</label>: {{item.participant.dob}}<br/>
                <label class="fw-bold">{{$t("message.phone")}}</label>: {{item.participant.phone}}<br/>
                <label class="fw-bold">{{$t("message.email")}}</label>: {{item.participant.email}}<br/>
              </td>
              <!-- <td class="align-middle text-center" style="vertical-align: middle;">{{item.participant.gender==1 ? "ប្រុស": item.participant.gender==2 ? "ស្រី" : ""}}</td>
              <td class="align-middle text-center" style="vertical-align: middle;">{{item.participant.dob}}</td>
              <td class="align-middle text-center" style="vertical-align: middle;">{{item.participant.phone}}</td> -->
              <td class="align-middle text-center" style="vertical-align: middle;">{{item.participant.nationality_name}}</td>
              <td class="align-middle text-center" style="vertical-align: middle;">{{item.participant.company_name }}</td>
              <td class="align-middle text-center" style="vertical-align: middle;">
                {{item.type_business_name}}
              </td>
              <td class="text-center align-middle" style="vertical-align: middle;">{{item.license_expiry_date}}</td>
              <td class="text-center align-middle">{{item.status ? $t("message.active") : $t("message.inactive")}}</td>
              <td class="text-center align-middle">
                <router-link class="btn btn-primary" :to="{ name: 'showParticipant' , params:{id:item.id}}"><i class="far fa-edit"></i></router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination v-model="search.page" 
            :records="total" 
            :per-page="search.limit" 
            @paginate="setPage($event)"/>
        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Choose Excel File</h5>
                <button type="button" 
                  class="btn-close" 
                  data-bs-dismiss="modal" 
                  aria-label="Close">
                </button>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <label for="formFile" class="form-label">Please choose your file excel.</label>
                  <input class="form-control" 
                    @change="onChange"
                    type="file" 
                    id="formFile" 
                    accept=".xlsx" 
                    ref="file">
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" @click="importExcel">Import</button>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import Pagination from 'v-pagination-3';
import axios from "@/axios";
export default {
  data() {
    return {
      filelist: []
      ,search: {
        firstname: '',
        lastname: '',
        phone: '',
        gender: '',
        company: '',
        expiration_query: '',
        status: '',
        nationality: '',
        page:1,
        limit:50
      }
      ,total:0
      ,listRegister: {}
    };
  },
  computed: { 
    getBusinessType(){
      return (t) =>{
        switch (t){
            case '1':
            case 1:
                return this.$t("message.stock_business");
            case '2':
            case 2:
                return this.$t("message.derivative_business");
            case '19':
            case 19:
                return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
            case 20:
            case '20':
                return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
            default:
                return t;
        }
      }
    }
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    searchAction(){
      //console.log(this.search);
      this.loadData();
    },
    async loadData(){
      let loader = this.showLoader();
      const respone = await axios.get("list-all-approve-person", {
        params: this.search,
        headers: {
          Authorization: "Bearer " + this.$store.getters.getAuthToken
        }
      });
      if (respone.status == 200) {
        this.listRegister = respone.data;
        this.total = respone.data.total;
      }
      loader.hide();
    },
    onChange() {
      this.filelist = this.$refs.file.files;
    },
    async importExcel(){
      let photoFormData = new FormData();
      photoFormData.append("file", this.filelist[0]);
      this.$swal
        .fire({
            title: this.$t("message.do_you_want_to_save"),
            showCancelButton: true,
            confirmButtonText: this.$t("message.yes"),
            cancelButtonText: this.$t("message.cancel")
        })
        .then(async (result) => {
            if (result.isConfirmed) {

              try {
                  const respone = await axios.post("import-quality-user", photoFormData, {
                  headers: {
                      Authorization: "Bearer " + this.$store.getters.getAuthToken
                  }
                  });
                  if (respone.status == 201) {
                      this.loadData();
                      this.$toast.open({
                          message: this.$t("message.save_successfully"),
                          type: "success",
                          duration: 5000,
                          dismissible: true,
                          position: "top-right"
                      });
                  }
              } catch (error) {
                  this.$toast.open({
                      message: error.response.data.message,
                      type: "error",
                      duration: 5000,
                      dismissible: true,
                      position: "top-right"
                  });
              }
            }
        });

    },
    setPage($event){
      this.search.page=$event;
      this.loadData();
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
   
  }, components: {
    Pagination
  }
};
</script>
<style scoped>

div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar a {
    float: left;
  }
  div.content {
    margin-left: 0;
  }
}

.footer {
  margin-left: 200px;
}
</style>
